import React from "react";

import "./ledgeritempositive.css";

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const Ledgeritempositive = (props) => {
  let _d = new Date(props.data.timestamp * 1000);
  return (
    <div className='ledgeritempositive-ledgeritempositive'>
      <span className='ledgeritempositive-typetext'>{props.data.transaction_type}</span>
      <span className='ledgeritempositive-nametext'>{props.data.participant}</span>
      <span className='ledgeritempositive-amounttext'>{numberWithCommas(props.data.amount) + " VT"}</span>
      <div className='ledgeritempositive-bottomcont'>
        <span className='ledgeritempositive-bytext'>{props.data.transacted_by}</span>
        <span className='ledgeritempositive-datetext'>{_d.toISOString().replace("T", " ")}</span>
      </div>
    </div>
  );
};

export default Ledgeritempositive;
